import { render, staticRenderFns } from "./TopUpModal.vue?vue&type=template&id=ba0f74be&scoped=true"
import script from "./TopUpModal.vue?vue&type=script&lang=js"
export * from "./TopUpModal.vue?vue&type=script&lang=js"
import style0 from "./TopUpModal.vue?vue&type=style&index=0&id=ba0f74be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0f74be",
  null
  
)

export default component.exports